import { render, staticRenderFns } from "./JobPreviewCompanyIntroduction.vue?vue&type=template&id=455bddf1&scoped=true"
import script from "./JobPreviewCompanyIntroduction.vue?vue&type=script&lang=js"
export * from "./JobPreviewCompanyIntroduction.vue?vue&type=script&lang=js"
import style0 from "./JobPreviewCompanyIntroduction.vue?vue&type=style&index=0&id=455bddf1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455bddf1",
  null
  
)

export default component.exports